// import Dispatcher from '../../../dispatcher/ApplicationDispatcher.js';
import {EventEmitter} from 'events';
import assign from 'object-assign';
import _ from 'underscore';
import xtend from 'xtend';

import WorkspaceConstants from '../WorkspaceConstants.js';
import Storage from '../../../utils/Storage.js';

function MessageStore (bus) {

    /**
     * Halts the API Polling Timer
     * @type {Boolean}
     */
    var _halt = false;

    // initialize localstorage messages
    var DefaultStoredMessages = {
        "info": {},
        "alert": {},
        "warning": {},
        "error": {}
    };

    if (!Storage.get('read-messages')) {
        Storage.set('read-messages', DefaultStoredMessages);
    }

    function getMessagesFromStorage () {
        return xtend(DefaultStoredMessages, Storage.get('read-messages'));
    }

    var messages = {
        info: {},
        alert: {},
        warning: {},
        error: {}
    };


    var MessageStore = assign({}, EventEmitter.prototype, {

        getState: function () {
            return {
                totalUnread: this.getTotalUnreadMessageCount(),
                halt: _halt,
                alertMessages: messages.alert,
                infoMessages: messages.info,
                warningMessages: messages.warning,
                errorMessages: messages.error
            };
        },

        getAlertMessages: function () {
            return messages.alert;
        },

        getInfoMessages: function () {
            return messages.info;
        },

        getWarningMessages: function () {
            return messages.warning;
        },

        getErrorMessages: function () {
            return messages.error;
        },

        getTotalUnreadMessageCount: function () {
            return _(messages).reduce(function (acc, msgs, msgType) {
                var unreadOfType = _(msgs).reduce(function (_acc, msg, msgId) {
                    return msg.meta.read ? _acc : _acc + 1;
                }, 0);
                return acc + unreadOfType;
            }, 0);
        },

        /*
            Flux
         */
        emitChange: function () {
            this.emit('change');
        },

        addChangeListener: function (callback) {
            this.on('change', callback);
        },

        removeChangeListener: function (callback) {
            this.removeListener('change', callback);
        }
    });

    /*
        Adds UI-specific properties to the given message
     */
    function sanitizeMessage (message) {
        message.meta = {
            read: false,
            readAt: null
        };

        return message;
    }

    // if a message is not in the API response, delete it from localstorage
    function deleteOldMessages (apiData) {
        var stored = getMessagesFromStorage();

        var filtered = _(stored).reduce(function (acc, msgsById, type) {
            var ids = Object.keys(msgsById);
            var keepThese = _.intersection(ids, _(apiData).pluck('msgID'));

            acc[type] = _(msgsById).reduce(function (_acc, msg, id) {
                if (keepThese.indexOf(id) > -1) _acc[id] = msg;
                return _acc;
            }, {});

            return acc;
        }, {});

        Storage.set('read-messages', filtered);

    }

    function populateReadMessagesFromStorage () {
        messages = getMessagesFromStorage();
    }

    function addNewMessage (msg) {
        messages[msg.msgType.toLowerCase()][msg.msgID] = sanitizeMessage(msg);
    }

    function handleStorageMarkAction (type, id) {

        var stored = getMessagesFromStorage();
        var message = messages[type][id];

        if (message.meta.read) {
            // Put Into Storage
            stored[type][id] = message;
        } else {
            // Remove From Storage
            delete stored[type][id];
        }

        Storage.set('read-messages', stored);
    }

    bus.on('action', function (payload) {
        var action = payload.action, data = payload.action.data;

        switch (action.actionType) {

            case WorkspaceConstants.MESSAGES_MARK:
                var msg = messages[data.type][data.id];
                var readAt = !msg.meta.read ? new Date() * 1 : null;
                msg.meta.readAt = readAt;
                msg.meta.read = !msg.meta.read;

                // Also Mark put/pop from storage so it's always up-to-date
                handleStorageMarkAction(data.type, data.id);

                MessageStore.emitChange();
                break;

            // reset our messages based on the API response
            case WorkspaceConstants.MESSAGES_FETCHED:

                deleteOldMessages(data.data);
                populateReadMessagesFromStorage();

                // store unread messages in memeory
                var byType = _(data.data).groupBy(function (msg) {
                    return msg.msgType.toLowerCase();
                });
                Object.keys(byType).forEach(function (type) {
                    byType[type].forEach(function (msg) {
                        if (!messages[type][msg.msgID]) {
                            messages[type][msg.msgID] = sanitizeMessage(msg);
                        }
                    });
                });

                MessageStore.emitChange();
                break;

            case WorkspaceConstants.NEW_MESSAGE:
                addNewMessage(data.data);
                MessageStore.emitChange();
                break;

            case WorkspaceConstants.APPLICATION_HALT:
                _halt = true;
                MessageStore.emitChange();
                break;

            case WorkspaceConstants.APPLICATION_RESUME:
                _halt = false;
                MessageStore.emitChange();
                break;

        }

    });

    return MessageStore;
};

export default MessageStore
